var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkerCritical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.657,
    height: 38.356,
    viewBox: "0 0 26.657 38.356",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2764",
    "data-name": "\\uADF8\\uB8F9 2764",
    transform: "translate(-854.425 -276.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_66",
    "data-name": "\\uD569\\uCE58\\uAE30 66",
    d: "M-7714-4266.088c0-6.575,5.746-11.912,12.83-11.912s12.828,5.337,12.828,11.912c0,9.265-12.828,25.148-12.828,25.148S-7714-4256.823-7714-4266.088Z",
    transform: "translate(8568.925 4555.375)",
    fill: "#cc2904",
    stroke: "#0a121e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-exclamation",
    "data-name": "Icon awesome-exclamation",
    d: "M5.291,11.248A2.083,2.083,0,1,1,3.208,9.165,2.085,2.085,0,0,1,5.291,11.248ZM1.366.656,1.72,7.738a.625.625,0,0,0,.624.594H4.072A.625.625,0,0,0,4.7,7.738L5.05.656A.625.625,0,0,0,4.426,0H1.99A.625.625,0,0,0,1.366.656Z",
    transform: "translate(864.545 282.573)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerCritical);
export default __webpack_public_path__ + "static/media/marker_critical.b6f8134e94b65512a25cb648626ea976.svg";
export { ForwardRef as ReactComponent };